<template>
        <div class="cs4-cart-coupon__element">
            <span class="cs4-cart-coupon__elementClose" v-on:click="$emit('removeCoupon')">
              <img class="cs4-cart-coupon__elementCloseIcon" src="https://comprasocial.me/wp-content/uploads/2022/10/icon-cross-bold.svg" alt="close icon">
            </span>
            <span class="cs4-cart-coupon__code">{{couponName}}</span>
        </div>
</template>

<script>
export default {
    props: ['couponName'],
    emits: ['removeCoupon'],
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
    .cs4-cart-coupon__element{
      background: linear-gradient(90deg, #F08968 0%, #FFB664 100%);
      border-radius: 10px;
      color: white;
      font-size: 13px;
      font-weight: 600;
      text-align: center;
      padding: 0 10px 0 5px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 7px;

      &Close {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 2px;
        cursor: pointer;

        &Icon {
          width: 15px;
          height: 15px;
          margin: 2px;
        }
      }
    }
</style>